<template>
  <div>
    <Assistant_teacher_bar />
    <v-container fluid>
      <base-material-card
        icon="mdi-clipboard-text"
        title="การประเมิน / ตรวจสอบผลประเมินฯ ตำแหน่งครูผู้ช่วย ครั้งที่ 1 - 4"
        class="px-5 py-3"
      >
        <!-- ===== ส่วนแจ้งยกเลิกคะแนน ===== -->
        <v-card flat>
          <v-card-text>
            <v-card class="mb-4 pa-2" outlined>
              <v-row>
                <!-- แจ้งยกเลิก -->
                <v-col cols="12">
                  <h2 class="red--text mb-2">
                    <v-icon color="red">mdi-alert</v-icon> แจ้งยกเลิกคะแนน
                  </h2>
                  <v-data-table
                    :loading="loading"
                    :headers="headersAlert"
                    :items="assistant_teachers"
                    :search="searchCC"
                    :items-per-page="5"
                  >
                    <template v-slot:top>
                      <v-text-field
                        v-model="searchCC"
                        append-icon="mdi-magnify"
                        label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง"
                        filled
                        dense
                      />
                    </template>

                    <template v-slot:item.assistant_teacher_comment="{ item }">
                      <div
                        v-if="item.assistant_teacher_comment === 'collegeCC'"
                      >
                        <v-btn
                          @click="cancelAssistant(item.assistant_teacher_id)"
                          rounded
                          small
                          color="error"
                        >
                          <v-icon small left>mdi-alert</v-icon> ยกเลิกไฟล์
                        </v-btn>
                        <div class="mt-1 caption">
                          {{ item.assistant_teacher_comment_detail }}
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.mt_date_app_now="{ item }">
                      {{
                        item.mt_date_app_now
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                    </template>

                    <template v-slot:item.assistant_teacher_datetime="{ item }">
                      {{
                        item.assistant_teacher_datetime
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                    </template>

                    <template v-slot:item.assistant_teacher_score="{ item }">
                      <div v-if="item.criteria_version === 'NEW'">
                        <v-chip
                          v-if="item.pass_status === 'pass'"
                          x-small
                          color="success"
                          dark
                          >ผ่าน</v-chip
                        >
                        <v-chip
                          v-else-if="item.pass_status === 'fail'"
                          x-small
                          color="error"
                          dark
                          >ไม่ผ่าน</v-chip
                        >
                        <v-chip v-else x-small outlined color="grey"
                          >รอตรวจ</v-chip
                        >
                      </div>
                      <div v-else>
                        <v-chip
                          v-if="item.assistant_teacher_score > 0"
                          x-small
                          :color="getScoreColor(item)"
                          dark
                        >
                          {{ item.assistant_teacher_score }}
                        </v-chip>
                      </div>
                    </template>

                    <template
                      v-slot:item.assistant_teacher_status="{ item }"
                    >
                      <v-chip
                        v-if="item.assistant_teacher_status === 'confirm'"
                        x-small
                        color="green"
                        dark
                      >
                        <v-icon x-small left>mdi-cube-send</v-icon>
                        ส่งผลแล้ว
                      </v-chip>
                      <v-btn
                        v-else
                        x-small
                        icon
                        color="info"
                        @click="viewFile(item.assistant_teacher_file)"
                      >
                        <v-icon x-small>mdi-printer</v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:item.assistant_teacher_ipacheck="{ item }">
                      <v-btn
                        fab
                        x-small
                        :color="getCheckColor(item.assistant_teacher_ipacheck)"
                        @click="checkAssistant(item.assistant_teacher_id)"
                      >
                        <v-icon x-small>{{
                          getCheckIcon(item.assistant_teacher_ipacheck)
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>

                <!-- รายการยกเลิก -->
                <v-col cols="12">
                  <h2 class="warning--text mb-2">
                    <v-icon color="warning">mdi-alert</v-icon> รายการยกเลิก
                  </h2>
                  <v-data-table
                    :loading="loading"
                    :headers="headersAlert"
                    :items="assistant_teachersCC"
                    :search="searchCC"
                    :items-per-page="5"
                  >
                    <template v-slot:item.mt_date_app_now="{ item }">
                      {{
                        item.mt_date_app_now
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                    </template>

                    <template v-slot:item.assistant_teacher_datetime="{ item }">
                      {{
                        item.assistant_teacher_datetime
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                    </template>

                    <template v-slot:item.assistant_teacher_score="{ item }">
                      <div v-if="item.criteria_version === 'NEW'">
                        <v-chip
                          v-if="item.pass_status === 'pass'"
                          x-small
                          color="success"
                          dark
                          >ผ่าน</v-chip
                        >
                        <v-chip
                          v-else-if="item.pass_status === 'fail'"
                          x-small
                          color="error"
                          dark
                          >ไม่ผ่าน</v-chip
                        >
                        <v-chip v-else x-small outlined color="grey"
                          >รอตรวจ</v-chip
                        >
                      </div>
                      <div v-else>
                        <v-chip
                          v-if="item.assistant_teacher_score > 0"
                          x-small
                          :color="getScoreColor(item)"
                          dark
                        >
                          {{ item.assistant_teacher_score }}
                        </v-chip>
                      </div>
                    </template>

                    <template
                      v-slot:item.assistant_teacher_status="{ item }"
                    >
                      <v-chip
                        v-if="item.assistant_teacher_status === 'confirm'"
                        x-small
                        color="green"
                        dark
                      >
                        ส่งผลแล้ว
                      </v-chip>
                      <v-btn
                        v-else
                        x-small
                        icon
                        color="info"
                        @click="viewFile(item.assistant_teacher_file)"
                      >
                        <v-icon x-small>mdi-printer</v-icon>
                      </v-btn>
                    </template>

                    <template v-slot:item.assistant_teacher_ipacheck="{ item }">
                      <v-btn
                        fab
                        x-small
                        :color="getCheckColor(item.assistant_teacher_ipacheck)"
                        @click="checkAssistant(item.assistant_teacher_id)"
                      >
                        <v-icon x-small>{{
                          getCheckIcon(item.assistant_teacher_ipacheck)
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </v-card>

        <!-- ===== ส่วนตรวจสอบผลประเมิน ===== -->
        <v-card flat>
          <v-card-text>
            <v-card class="mb-4 pa-2" outlined>
              <h2 class="success--text mb-3">
                <v-icon color="success">mdi-check-decagram</v-icon>
                ตรวจสอบผลประเมินฯ
              </h2>
              <v-row no-gutters>
                <v-col cols="12" md="4" class="pa-1">
                  <v-autocomplete
                    outlined
                    dense
                    label="ค้นหา วิทยาลัย :"
                    :items="colleges"
                    item-text="college_name"
                    item-value="college_code"
                    v-model="college_select"
                    @change="personnel_temporaryCollegeQueryAll()"
                  ></v-autocomplete>
                  <v-text-field
                    outlined
                    dense
                    v-model="updateorder_app_now.order_app_now"
                    label="ปรับปรุงคำสั่งที่บรรจุ คำสั่งที่ :"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" md="8" class="pa-1">
                  <v-simple-table dense>
                    <tbody>
                      <tr>
                        <td class="text-center" colspan="2">
                          <v-btn
                            :href="
                              '#/admin/print_AssismentReportCPDay2/?appoin_day=' +
                                appoin_day +
                                '&appoin_month=' +
                                appoin_month +
                                '&appoin_year=' +
                                appoin_year +
                                '&mt_type_personnel=' +
                                (mt_type_personnel || 0) +
                                '&mt_admissions_status=' +
                                (mt_admissions_status || 0)
                            "
                            target="_blank"
                            color="info"
                            small
                            v-if="check_param_query > 1"
                          >
                            <v-icon small left>mdi-printer</v-icon>
                            พิมพ์รายงาน
                          </v-btn>
                        </td>
                        <td class="text-center" colspan="2">
                          <v-btn small @click="UpdateSystem()" color="success">
                            <v-icon small left>mdi-update</v-icon>Update
                          </v-btn>
                        </td>
                        <td class="text-center" colspan="2">
                          <v-btn
                            small
                            outlined
                            @click="checkappoint()"
                            color="info"
                          >
                            <v-icon small left>mdi-magnify</v-icon>Show All
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center" colspan="3">
                          <v-btn
                            small
                            outlined
                            @click="assistant_teacherQueryAll()"
                            color="warning"
                          >
                            <v-icon small left>mdi-magnify</v-icon
                            >คะแนนต่ำกว่าเกณฑ์
                          </v-btn>
                        </td>
                        <td class="text-center" colspan="3">
                          <v-btn
                            small
                            outlined
                            @click="assistant_teacher_update()"
                            color="success"
                          >
                            <v-icon small left>mdi-magnify</v-icon
                            >ปรับปรุงคะแนน
                          </v-btn>
                        </td>
                      </tr>
                      <tr>
                        <td colspan="6" class="text-center">
                          จำนวนทั้งสิ้น
                          <strong>{{ checkdatareport.countall }}</strong> อัตรา
                        </td>
                      </tr>
                      <!-- หัวตาราง -->
                      <tr class="summary-header">
                        <td class="text-center font-weight-bold">ครั้งที่</td>
                        <td class="text-center font-weight-bold">ให้ผ่าน</td>
                        <td class="text-center font-weight-bold">ไม่ให้ผ่าน</td>
                        <td class="text-center font-weight-bold">
                          ต่ำกว่าเกณฑ์
                        </td>
                        <td class="text-center font-weight-bold">
                          ไม่ได้ดำเนินการ
                        </td>
                        <td class="text-center font-weight-bold">ไม่รายงาน</td>
                      </tr>
                      <tr v-for="t in [1, 2, 3, 4]" :key="'summary-' + t">
                        <td class="text-center font-weight-bold">
                          ครั้งที่ {{ t }}
                        </td>
                        <td class="text-center success--text">
                          <v-icon x-small color="success"
                            >mdi-check-circle</v-icon
                          >
                          {{ checkdatareport["counttime" + t + "pass"] }}
                        </td>
                        <td class="text-center red--text">
                          <v-icon x-small color="error">mdi-close</v-icon>
                          {{ checkdatareport["counttime" + t + "notpass"] }}
                        </td>
                        <td class="text-center">
                          <span
                            v-if="
                              timelowscore['counttime' + t + 'lowscore'] > 0
                            "
                            class="error--text"
                          >
                            <v-icon x-small color="error">mdi-alert</v-icon>
                            {{ timelowscore["counttime" + t + "lowscore"] }}
                          </span>
                        </td>
                        <td class="text-center warning--text">
                          <v-icon x-small color="warning">mdi-alert</v-icon>
                          {{ checkdatareport["counttime" + t + "notcheck"] }}
                        </td>
                        <td class="text-center error--text">
                          <v-icon x-small color="error">mdi-alert</v-icon>
                          {{ checkdatareport["counttime" + t + "null"] }}
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
                <v-col
                  cols="12"
                  md="6"
                  class="text-center"
                  v-if="updateorder_app_now.order_app_now"
                >
                  <v-btn small @click="updateOrder()" color="success">
                    <v-icon small left>mdi-update</v-icon> Update
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>

            <!-- ===== ตารางหลัก ===== -->
            <v-data-table
              :page.sync="currentPage"
              :headers="showHeaders"
              :items="manage_assistant_teacher"
              :loading="loading"
              :search="search"
              :items-per-page="10"
            >
              <template v-slot:top>
                <v-text-field
                  @keyup="checkmanage_assistant_teacherid"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา ระบุคำ หรือ ส่วนข้อความเกี่ยวข้อง หรือค้นหาด้วยรหัสบัตรประชาชน และ กด Enter"
                  filled
                  dense
                  class="mb-2"
                />
                <v-select
                  v-model="selectedHeaders"
                  :items="headers"
                  label="เลือกคอลัมน์ที่ต้องการแสดง"
                  multiple
                  outlined
                  dense
                  return-object
                >
                  <template v-slot:selection="{ item, index }">
                    <v-chip small v-if="index < 6">{{ item.text }}</v-chip>
                    <span v-if="index === 6" class="grey--text caption"
                      >(+{{ selectedHeaders.length - 6 }} คอลัมน์)</span
                    >
                  </template>
                </v-select>
              </template>

              <!-- Login Admin -->
              <template v-slot:item.LoginAdmin="{ item }">
                <v-icon
                  v-if="user_id.userauthorityAdmin === '1'"
                  color="info"
                  small
                  @click="userLogin(item.user_name, item.user_password)"
                >
                  mdi-puzzle
                </v-icon>
              </template>

              <!-- ประเภท -->
              <template v-slot:item.mt_type_personnel="{ item }">
                <v-chip
                  x-small
                  :color="getTypeColor(item.mt_type_personnel)"
                  dark
                >
                  {{ getTypeLabel(item.mt_type_personnel) }}
                </v-chip>
              </template>

              <!-- ใบประกอบวิชาชีพ -->
              <template v-slot:item.pt_licence="{ item }">
                <div v-if="item.mt_license_status === 'have'">
                  <v-icon color="info" size="18"
                    >mdi-card-account-details-star</v-icon
                  >
                </div>
                <div v-else-if="item.mt_license_status === 'donot'">
                  <v-icon color="warning" size="18"
                    >mdi-card-bulleted-off</v-icon
                  >
                  <div v-if="item.pt_licence_tem">
                    <div v-if="String(item.pt_licence_file_tem).length < 10">
                      <v-chip x-small color="error" outlined>
                        <v-icon x-small>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                      </v-chip>
                    </div>
                    <div v-else>
                      <v-chip
                        @click="viewpdflicenseteach(item.pt_licence_file_tem)"
                        x-small
                        outlined
                        color="info"
                      >
                        <v-icon x-small>mdi-magnify</v-icon>
                        {{ item.pt_licence_tem }}
                      </v-chip>
                    </div>
                    <div class="caption">
                      หมดอายุ
                      {{
                        item.pt_enddate_tem
                          | moment("add", "543 year")
                          | moment("D MMM YYYY")
                      }}
                    </div>
                    <div
                      v-if="item.datediffendtem <= 0"
                      class="red--text caption font-weight-bold"
                    >
                      <v-icon x-small color="red">mdi-alert</v-icon>
                      หมดก่อน {{ item.datediffendtem }} วัน
                    </div>
                    <v-btn
                      icon
                      x-small
                      @click="updateLicense(item.mt_id)"
                      color="grey"
                    >
                      <v-icon x-small>mdi-magnify-close</v-icon>
                    </v-btn>
                  </div>
                </div>
                <div v-else-if="item.mt_license_status === 'waitpl'">
                  <v-chip x-small color="warning">P License (รอ)</v-chip>
                </div>
                <div v-else>
                  <v-btn
                    @click="updatemanage_assistant_teacher_id(item.mt_id)"
                    x-small
                    rounded
                    outlined
                    color="warning"
                  >
                    <v-icon x-small>mdi-alert</v-icon> ไม่มี
                  </v-btn>
                </div>
                <!-- สถานะตรวจ -->
                <div v-if="item.pt_licence_file_ipa === 'pass'">
                  <v-icon x-small color="success">mdi-check-circle</v-icon>
                </div>
                <div
                  v-else-if="item.pt_licence_file_ipa === 'dontpass'"
                  class="red--text caption"
                >
                  {{ item.pt_licence_file_ipacomment }}
                </div>
                <!-- แสดงเลขใบอนุญาต -->
                <div v-if="item.pt_licence">
                  <div v-if="String(item.pt_licence_file).length < 10">
                    <v-chip x-small color="error" outlined>
                      <v-icon x-small>mdi-alert</v-icon> ไม่ได้แนบไฟล์
                    </v-chip>
                  </div>
                  <div v-else>
                    <v-chip
                      @click="viewpdflicenseteach(item.pt_licence_file)"
                      x-small
                      outlined
                      color="info"
                    >
                      <v-icon x-small>mdi-magnify</v-icon>
                      {{ item.pt_licence }}
                    </v-chip>
                  </div>
                  <div class="caption">
                    หมดอายุ
                    {{
                      item.pt_enddate
                        | moment("add", "543 year")
                        | moment("D MMM YYYY")
                    }}
                  </div>
                  <div
                    v-if="item.datediffend <= 0"
                    class="red--text caption font-weight-bold"
                  >
                    <v-icon x-small color="red">mdi-alert</v-icon>
                    หมดก่อน {{ item.datediffend }} วัน
                  </div>
                  <v-btn
                    icon
                    x-small
                    @click="updateLicense(item.mt_id)"
                    color="grey"
                  >
                    <v-icon x-small>mdi-magnify-close</v-icon>
                  </v-btn>
                </div>
              </template>

              <!-- คุรุสภา -->
              <template v-slot:item.pt_licence_ict="{ item }">
                <v-icon
                  x-small
                  :color="item.pt_licence_ict === 'ict' ? 'green' : 'red'"
                >
                  {{
                    item.pt_licence_ict === "ict"
                      ? "mdi-check-circle"
                      : "mdi-close"
                  }}
                </v-icon>
              </template>

              <!-- วันลา -->
              <template v-slot:item.assistant_teacher_re_leaveday="{ item }">
                <div v-if="item.assistant_teacher_re_leaveday">
                  <v-icon x-small color="info">mdi-calendar</v-icon>
                  {{ item.assistant_teacher_re_leaveday }}
                </div>
                <div v-if="item.assistant_teacher_re_leaveguarantee">
                  <v-btn
                    icon
                    x-small
                    color="success"
                    @click="
                      viewFileLeave(item.assistant_teacher_re_leaveguarantee)
                    "
                  >
                    <v-icon x-small>mdi-printer</v-icon>
                  </v-btn>
                </div>
              </template>

              <!-- เสนอรายชื่อกรรมการ -->
              <template v-slot:item.mt_committe_file="{ item }">
                <div
                  v-if="item.mt_committe_ipaapprove === 'dontpass'"
                  class="red--text caption"
                >
                  {{ item.mt_committe_ipaapprove_detail }}
                </div>
                <div v-if="item.mt_committe_ipaapprove === 'pass'">
                  <v-icon x-small color="success">mdi-check-circle</v-icon>
                </div>
                <div v-if="item.mt_committe_file">
                  <v-btn
                    color="info"
                    icon
                    x-small
                    @click="viewFile(item.mt_committe_file)"
                  >
                    <v-icon x-small>mdi-printer</v-icon>
                  </v-btn>
                </div>
              </template>

              <!-- ===== ครั้งที่ 1-4 sub-scores ===== -->
              <template v-slot:item.mt_time_1_score_a="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_1_score_a"
                  :total="item.mt_time_1_score"
                  :threshold="24"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_1_score_b="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_1_score_b"
                  :total="item.mt_time_1_score"
                  :threshold="36"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_2_score_a="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_2_score_a"
                  :total="item.mt_time_2_score"
                  :threshold="24"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_2_score_b="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_2_score_b"
                  :total="item.mt_time_2_score"
                  :threshold="36"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_3_score_a="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_3_score_a"
                  :total="item.mt_time_3_score"
                  :threshold="28"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_3_score_b="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_3_score_b"
                  :total="item.mt_time_3_score"
                  :threshold="42"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_4_score_a="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_4_score_a"
                  :total="item.mt_time_4_score"
                  :threshold="28"
                  :criteriaVersion="item.criteria_version"
                />
              </template>
              <template v-slot:item.mt_time_4_score_b="{ item }">
                <ScoreSubAdmin
                  :score="item.mt_time_4_score_b"
                  :total="item.mt_time_4_score"
                  :threshold="42"
                  :criteriaVersion="item.criteria_version"
                />
              </template>

              <!-- ===== ครั้งที่ 1-4 main scores ===== -->
              <template v-slot:item.mt_time_1_score="{ item }">            
                <ScoreCellAdmin
                  :item="item"
                  :timeNo="1"
                  :passThresholdA="24"
                  :passThresholdB="36"
                  :passThreshold="60"
                  @check="checkAssistant"
                  @view-file="viewFile"
                  @view-committee="viewCommitteeDetail"
                />
              </template>
              <template v-slot:item.mt_time_2_score="{ item }">
                <ScoreCellAdmin
                  :item="item"
                  :timeNo="2"
                  :passThresholdA="24"
                  :passThresholdB="36"
                  :passThreshold="60"
                  @check="checkAssistant"
                  @view-file="viewFile"
                  @view-committee="viewCommitteeDetail"
                />
              </template>
              <template v-slot:item.mt_time_3_score="{ item }">
                <ScoreCellAdmin
                  :item="item"
                  :timeNo="3"
                  :passThresholdA="28"
                  :passThresholdB="42"
                  :passThreshold="70"
                  @check="checkAssistant"
                  @view-file="viewFile"
                  @view-committee="viewCommitteeDetail"
                />
              </template>
              <template v-slot:item.mt_time_4_score="{ item }">
                <ScoreCellAdmin
                  :item="item"
                  :timeNo="4"
                  :passThresholdA="28"
                  :passThresholdB="42"
                  :passThreshold="70"
                  @check="checkAssistant"
                  @view-file="viewFile"
                  @view-committee="viewCommitteeDetail"
                />
              </template>

              <!-- วันเดือนปีบรรจุ -->
              <template v-slot:item.mt_date_app_now="{ item }">
                {{
                  item.mt_date_app_now
                    | moment("add", "543 year")
                    | moment("D MMMM YYYY")
                }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </base-material-card>

      <!-- ===== Dialog ตรวจสอบ (เพิ่มรองรับเกณฑ์ใหม่) ===== -->
      <v-dialog
        v-model="editpersonnel_temporaryCheckdialog"
        persistent
        max-width="60%"
      >
        <v-card class="mx-auto pa-6">
          <base-material-card
            color="warning"
            icon="mdi-clipboard-text"
            title="การตรวจสอบข้อมูล ผลการประเมิน"
            class="px-5 py-3"
          ></base-material-card>
          <v-card-text>
            <v-form ref="editpersonnel_temporaryCheckform" lazy-validation>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex md12>
                    <!-- ปุ่มดูไฟล์ -->
                    <div
                      v-if="
                        String(
                          assistant_teachers_edit.assistant_teacher_file
                        ).length > 4
                      "
                      class="text-center"
                    >
                      <v-btn
                        @click="
                          viewFile(
                            assistant_teachers_edit.assistant_teacher_file
                          )
                        "
                        color="info"
                        icon
                      >
                        <v-icon size="40">mdi-printer</v-icon>
                      </v-btn>
                    </div>

                    {{ assistant_teachers_edit.user_firstname }}<br />
                    ชื่อ-นามสกุล :
                    <strong>{{ assistant_teachers_edit.frist_names }}</strong
                    ><br />
                    ครั้งที่ :
                    {{ assistant_teachers_edit.assistant_teacher_times }}

                    <!-- ===== เกณฑ์ใหม่: แสดงผล pass/fail ===== -->
                    <div
                      v-if="
                        assistant_teachers_edit.criteria_version === 'NEW'
                      "
                      class="text-center my-3"
                    >
                      <v-chip
                        label
                        color="blue"
                        dark
                        small
                        class="mb-2"
                      >
                        <v-icon small left>mdi-new-box</v-icon>
                        เกณฑ์ใหม่ ว19/2568
                      </v-chip>
                      <div>
                        <v-chip
                          :color="
                            assistant_teachers_edit.pass_status === 'pass'
                              ? 'success'
                              : 'error'
                          "
                          dark
                        >
                          <v-icon left>{{
                            assistant_teachers_edit.pass_status === "pass"
                              ? "mdi-check-circle"
                              : "mdi-close-circle"
                          }}</v-icon>
                          {{
                            assistant_teachers_edit.pass_status === "pass"
                              ? "ผ่าน"
                              : "ไม่ผ่าน"
                          }}
                        </v-chip>
                      </div>
                      <v-btn
                        small
                        text
                        color="info"
                        class="mt-2"
                        @click="
                          viewCommitteeDetail(
                            assistant_teachers_edit.assistant_teacher_id
                          )
                        "
                      >
                        <v-icon small left>mdi-account-group</v-icon>
                        ดูรายละเอียดกรรมการ
                      </v-btn>
                    </div>

                    <!-- ===== เกณฑ์เดิม: แสดงคะแนน ===== -->
                    <div
                      v-else
                      class="text-center font-weight-bold my-3"
                    >
                      <div
                        v-if="
                          assistant_teachers_edit.assistant_teacher_times ===
                            '1' ||
                            assistant_teachers_edit.assistant_teacher_times ===
                              '2'
                        "
                      >
                        ด้านที่ 1 :
                        <span
                          :class="
                            assistant_teachers_edit.assistant_teacher_score_a >=
                            24
                              ? 'success--text'
                              : 'red--text'
                          "
                        >
                          {{
                            assistant_teachers_edit.assistant_teacher_score_a
                          }}
                        </span>
                        | ด้านที่ 2 :
                        <span
                          :class="
                            assistant_teachers_edit.assistant_teacher_score_b >=
                            36
                              ? 'success--text'
                              : 'red--text'
                          "
                        >
                          {{
                            assistant_teachers_edit.assistant_teacher_score_b
                          }}
                        </span>
                        <div
                          :class="
                            assistant_teachers_edit.assistant_teacher_score >=
                            60
                              ? 'success--text'
                              : 'red--text'
                          "
                        >
                          คะแนนรวม :
                          {{ assistant_teachers_edit.assistant_teacher_score }}
                        </div>
                      </div>
                      <div
                        v-if="
                          assistant_teachers_edit.assistant_teacher_times ===
                            '3' ||
                            assistant_teachers_edit.assistant_teacher_times ===
                              '4'
                        "
                      >
                        ด้านที่ 1 :
                        <span
                          :class="
                            assistant_teachers_edit.assistant_teacher_score_a >=
                            28
                              ? 'success--text'
                              : 'red--text'
                          "
                        >
                          {{
                            assistant_teachers_edit.assistant_teacher_score_a
                          }}
                        </span>
                        | ด้านที่ 2 :
                        <span
                          :class="
                            assistant_teachers_edit.assistant_teacher_score_b >=
                            42
                              ? 'success--text'
                              : 'red--text'
                          "
                        >
                          {{
                            assistant_teachers_edit.assistant_teacher_score_b
                          }}
                        </span>
                        <div
                          :class="
                            assistant_teachers_edit.assistant_teacher_score >=
                            70
                              ? 'success--text'
                              : 'red--text'
                          "
                        >
                          คะแนนรวม :
                          {{ assistant_teachers_edit.assistant_teacher_score }}
                        </div>
                      </div>
                    </div>

                    <div class="text-center caption">
                      วันที่ประเมิน :
                      {{
                        assistant_teachers_edit.assistant_teacher_datetime
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                      | วันที่รายงาน :
                      {{
                        assistant_teachers_edit.assistant_teacher_datetimest
                          | moment("add", "543 year")
                          | moment("D MMMM YYYY")
                      }}
                    </div>
                  </v-flex>

                  <v-flex md6>
                    <v-radio-group
                      v-model="
                        assistant_teachers_edit.assistant_teacher_ipacheck
                      "
                      row
                      :rules="[v => !!v || '']"
                    >
                      <template v-slot:label>
                        <div><strong>การตรวจสอบข้อมูล</strong></div>
                      </template>
                      <v-radio value="Pass">
                        <template v-slot:label>
                          <strong class="success--text">ผ่าน</strong>
                        </template>
                      </v-radio>
                      <v-radio value="NotPass">
                        <template v-slot:label>
                          <strong class="primary--text">ไม่ผ่าน</strong>
                        </template>
                      </v-radio>
                    </v-radio-group>
                  </v-flex>

                  <v-flex
                    md6
                    v-if="
                      assistant_teachers_edit.assistant_teacher_ipacheck ===
                        'NotPass'
                    "
                  >
                    <v-text-field
                      label="เหตุผล"
                      v-model="
                        assistant_teachers_edit.assistant_teacher_ipacomment
                      "
                      required
                      :rules="[v => !!v || '']"
                      outlined
                      dense
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn
              outlined
              small
              color="warning"
              @click.stop="editassistant_teacherCancelSubmit()"
              rounded
            >
              <v-icon small left>mdi-close-circle</v-icon>ยกเลิกการตรวจ
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              small
              color="grey"
              outlined
              @click.stop="editpersonnel_temporaryCheckdialog = false"
              rounded
            >
              <v-icon small left>mdi-close</v-icon>ปิด
            </v-btn>
            <v-btn
              small
              outlined
              color="green"
              @click.stop="editassistant_teacherSubmit()"
              rounded
            >
              <v-icon small left>mdi-content-save</v-icon>บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog ดูรายละเอียดกรรมการ ===== -->
      <v-dialog v-model="committeeDetailDialog" max-width="700">
        <v-card class="pa-4">
          <v-card-title>
            <v-icon color="info" left>mdi-account-group</v-icon>
            รายละเอียดคะแนนรายกรรมการ
            <v-spacer></v-spacer>
            <v-btn icon @click="committeeDetailDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-data-table
            :headers="committeeDetailHeaders"
            :items="committeeDetailItems"
            disable-pagination
            hide-default-footer
          >
            <template v-slot:item.pass_profession="{ item }">
              <v-icon
                x-small
                :color="
                  item.pass_profession === 'pass' ? 'success' : 'error'
                "
              >
                {{
                  item.pass_profession === "pass"
                    ? "mdi-check-circle"
                    : "mdi-close-circle"
                }}
              </v-icon>
              {{ item.score_profession }}
            </template>
            <template v-slot:item.pass_social="{ item }">
              <div v-if="item.score_social !== null">
                <v-icon
                  x-small
                  :color="
                    item.pass_social === 'pass' ? 'success' : 'error'
                  "
                >
                  {{
                    item.pass_social === "pass"
                      ? "mdi-check-circle"
                      : "mdi-close-circle"
                  }}
                </v-icon>
                {{ item.score_social }}
              </div>
              <span v-else class="grey--text">-</span>
            </template>
            <template v-slot:item.pass_personality="{ item }">
              <v-icon
                x-small
                :color="
                  item.pass_personality === 'pass' ? 'success' : 'error'
                "
              >
                {{
                  item.pass_personality === "pass"
                    ? "mdi-check-circle"
                    : "mdi-close-circle"
                }}
              </v-icon>
              {{ item.score_personality }}
            </template>
            <template v-slot:item.overall_pass="{ item }">
              <v-chip
                x-small
                :color="item.overall_pass === 'pass' ? 'success' : 'error'"
                dark
              >
                {{ item.overall_pass === "pass" ? "ผ่าน" : "ไม่ผ่าน" }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card>
      </v-dialog>

      <!-- ===== Dialog อื่นๆ (เหมือนเดิม) ===== -->
      <!-- PDF viewer dialogs -->
      <v-dialog v-model="pdflicenseteachdialog" max-width="80%">
        <v-card elevation="2">
          <embed
            :src="'/HRvecLicenseTeach/' + pt_licence_files"
            width="100%"
            height="700px"
          />
        </v-card>
      </v-dialog>

      <v-dialog v-model="assistant_teacher_filedialog" max-width="80%">
        <v-card elevation="2">
          <embed
            :src="'/HRvecfiles/' + filesAss"
            width="100%"
            height="700px"
          />
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="assistant_teacher_re_leaveguaranteedialog"
        max-width="80%"
      >
        <v-card elevation="2">
          <embed
            :src="
              'https://hrvec.ovec.go.th/HRvecAssistant_report/' +
                assistant_teacher_re_leaveguarantee
            "
            width="100%"
            height="700px"
          />
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon>
        <v-card-text>{{ snackbar.text }}</v-card-text>
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false"
            >Close</v-btn
          >
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import Assistant_teacher_bar from "../../components/admin/assistant_teacher_bar.vue";
import ScoreCellAdmin from "../../components/admin/ScoreCellAdmin.vue";
import ScoreSubAdmin from "../../components/admin/ScoreSubAdmin.vue";

export default {
  components: {
    Assistant_teacher_bar,
    ScoreCellAdmin,
    ScoreSubAdmin
  },
  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      editpersonnel_temporarydialog: false,
      evaluate_assistantdialog: false,
      assistant_teacherdialog: false,
      assistant_teacherEditdialog: false,
      assistant_teacherConfirmdialog: false,
      cancel_assistant_teacher_reportdialog: false,
      pertem_assistantFileCCdialog: false,
      editpersonnel_temporaryCheckdialog: false,
      committeeDetailDialog: false,
      committeeDetailItems: [],
      committeeDetailHeaders: [
        { text: "คนที่", align: "center", value: "committee_no" },
        { text: "ชื่อ-นามสกุล", align: "left", value: "committee_name" },
        { text: "ตำแหน่ง", align: "left", value: "committee_position" },
        { text: "ด้านวิชาชีพ", align: "center", value: "pass_profession" },
        { text: "ด้านสังคม", align: "center", value: "pass_social" },
        { text: "ด้านคุณลักษณะ", align: "center", value: "pass_personality" },
        { text: "ผลรวม", align: "center", value: "overall_pass" }
      ],
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      manage_assistant_teacher: [],
      addpersonnel_temporary: {},
      editpersonnel_temporary: {},
      search: "",
      searchCC: "",
      pagination: {},
      headers: [],
      selectedHeaders: [],
      headersMap: [
        { text: "ลำดับ", align: "center", value: "order_number" },
        { text: "ประเภท", align: "left", value: "mt_type_personnel" },
        { text: "รหัสสถานศึกษา", align: "left", value: "mt_college_code" },
        { text: "เข้าสู่ระบบ", align: "left", value: "LoginAdmin" },
        { text: "สถานศึกษา", align: "left", value: "agency" },
        { text: "จังหวัด", align: "left", value: "province_name" },
        { text: "ภาค", align: "left", value: "region_name" },
        { text: "รหัสบัตรประชาชน", align: "left", value: "mt_id_card" },
        { text: "คำนำหน้าชื่อ", align: "left", value: "mt_title_s" },
        { text: "ชื่อ", align: "left", value: "mt_frist_name" },
        { text: "สกุล", align: "left", value: "mt_last_name" },
        { text: "เลขที่ตำแหน่ง", align: "center", value: "mt_id_position" },
        { text: "ใบประกอบวิชาชีพ", align: "center", value: "pt_licence" },
        { text: "คุรุสภา", align: "center", value: "pt_licence_ict" },
        {
          text: "วันลา",
          align: "center",
          value: "assistant_teacher_re_leaveday"
        },
        {
          text: "เสนอรายชื่อกรรมการ",
          align: "center",
          value: "mt_committe_file"
        },
        {
          text: "ครั้งที่ 1(1)",
          align: "center",
          value: "mt_time_1_score_a"
        },
        {
          text: "ครั้งที่ 1(2)",
          align: "center",
          value: "mt_time_1_score_b"
        },
        { text: "ครั้งที่ 1", align: "center", value: "mt_time_1_score" },
        {
          text: "ครั้งที่ 2(1)",
          align: "center",
          value: "mt_time_2_score_a"
        },
        {
          text: "ครั้งที่ 2(2)",
          align: "center",
          value: "mt_time_2_score_b"
        },
        { text: "ครั้งที่ 2", align: "center", value: "mt_time_2_score" },
        {
          text: "ครั้งที่ 3(1)",
          align: "center",
          value: "mt_time_3_score_a"
        },
        {
          text: "ครั้งที่ 3(2)",
          align: "center",
          value: "mt_time_3_score_b"
        },
        { text: "ครั้งที่ 3", align: "center", value: "mt_time_3_score" },
        {
          text: "ครั้งที่ 4(1)",
          align: "center",
          value: "mt_time_4_score_a"
        },
        {
          text: "ครั้งที่ 4(2)",
          align: "center",
          value: "mt_time_4_score_b"
        },
        { text: "ครั้งที่ 4", align: "center", value: "mt_time_4_score" },
        { text: "วันเดือนปีบรรจุ", align: "center", value: "mt_date_app_now" }
      ],
      headersAlert: [
        { text: "วันที่บรรจุ", align: "center", value: "mt_date_app_now" },
        { text: "รหัสสถานศึกษา", align: "left", value: "user_code" },
        { text: "สถานศึกษา", align: "center", value: "user_firstname" },
        {
          text: "รหัสบัตรประชาชน",
          align: "left",
          value: "assistant_teacher_id_card"
        },
        { text: "ชื่อ-นามสกุล", align: "left", value: "frist_names" },
        {
          text: "ครั้งที่",
          align: "center",
          value: "assistant_teacher_times"
        },
        {
          text: "วันที่ประเมิน",
          align: "center",
          value: "assistant_teacher_datetime"
        },
        {
          text: "คะแนน/ผล",
          align: "center",
          value: "assistant_teacher_score"
        },
        { text: "สถานะ", align: "center", value: "assistant_teacher_status" },
        {
          text: "รายละเอียด",
          align: "center",
          value: "assistant_teacher_comment_detail"
        },
        {
          text: "ดำเนินการ",
          align: "center",
          value: "assistant_teacher_ipacheck"
        },
        {
          text: "หมายเหตุ",
          align: "center",
          value: "assistant_teacher_ipacomment"
        }
      ],
      headers_aassistant_teacher: [
        {
          text: "ครั้งที่",
          align: "center",
          value: "assistant_teacher_times"
        },
        { text: "สถานศึกษา", align: "left", value: "college_name" },
        {
          text: "รหัสบัตรประชาชน",
          align: "left",
          value: "assistant_teacher_mt_id_card"
        },
        { text: "ชื่อ-นามสกุล", align: "left", value: "mt_frist_names" },
        {
          text: "วันที่ประเมิน",
          align: "center",
          value: "assistant_teacher_datetime"
        },
        {
          text: "คะแนน",
          align: "center",
          value: "assistant_teacher_score"
        },
        { text: "สถานะ", align: "center", value: "assistant_teacher_status" },
        {
          text: "หมายเหตุ",
          align: "center",
          value: "assistant_teacher_comment"
        }
      ],
      college: {},
      colleges: [],
      college_select: "",
      provinces: [],
      regions: [],
      assistant_teachers: [],
      assistant_teachersCC: [],
      addassistant_teacher: {},
      assistant_teachers_edit: [],
      assistant_teachers_confrim: {},
      assistant_teacher_report_s: {},
      result_assistant_teacher_reports: {},
      cancel_assistant_teacher_reports: {},
      cancel_assistant_teachers: {},
      data_syslog: {},
      Updatepersonnel_temporary: {},
      Updatemanage_assistant_teacher: {},
      upManageAss: {},
      updateorder_app_now: {},
      updateorder_app_now_ms: {},
      editmanage_assistant_teacher: [],
      personnel_temporary_mt_id_card: [],
      pdflicenseteachdialog: false,
      pt_licence_files: "",
      filesAss: "",
      assistant_teacher_filedialog: false,
      cancel_committeefiledialog: false,
      cancel_Licensefiledialog: false,
      checkdatareport: [],
      timelowscore: [],
      currentPage: 1,
      user_id: [],
      check_param_query: "",
      assistant_teacher_re_leaveguarantee: "",
      assistant_teacher_re_leaveguaranteedialog: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false
    };
  },
  async created() {
    this.headers = Object.values(this.headersMap);
    this.selectedHeaders = this.headers;
  },
  async mounted() {
    await this.userQueryID();
    let result = await this.$http.post("college.php", {
      ApiKey: this.ApiKey
    });
    this.colleges = result.data;
    await this.checkappoint();
    await this.assistant_teacherscollegeCCQueryAll();
    await this.assistant_teachersCCQueryAll();
  },
  methods: {
    // ===== Helper methods =====
    getScoreColor(item) {
      const times = String(item.assistant_teacher_times);
      const score = parseFloat(item.assistant_teacher_score);
      if (times === "1" || times === "2")
        return score >= 60 ? "success" : "error";
      if (times === "3" || times === "4")
        return score >= 70 ? "success" : "error";
      return "grey";
    },
    getTypeColor(type) {
      if (type === "local_dev") return "info";
      if (type === "transfer_position") return "warning";
      return "success";
    },
    getTypeLabel(type) {
      if (type === "local_dev") return "พัฒนาท้องถิ่น";
      if (type === "transfer_position") return "โอนย้าย";
      return "ปกติ";
    },
    getCheckColor(status) {
      if (status === "Pass") return "success";
      if (status === "NotPass") return "red";
      return "warning";
    },
    getCheckIcon(status) {
      if (status === "Pass") return "mdi-account-check";
      if (status === "NotPass") return "mdi-account-remove";
      return "mdi-account-edit";
    },

    async viewCommitteeDetail(assistant_teacher_id) {
      try {
        let result = await this.$http.post(
          "assistant_teacher_committee.php",
          {
            ApiKey: this.ApiKey,
            assistant_teacher_id: assistant_teacher_id
          }
        );
        console.log("assistant_teacher_id:", assistant_teacher_id);  
        console.log("Committee Detail Result:", result);  
        this.committeeDetailItems = result.data || [];
        this.committeeDetailDialog = true;
      } catch (e) {
        console.error("Error loading committee detail:", e);
      }
    },

    async viewFileLeave(file) {
      this.assistant_teacher_re_leaveguarantee = file;
      this.assistant_teacher_re_leaveguaranteedialog = true;
    },

    async userQueryID() {
      let userSession = JSON.parse(sessionStorage.getItem("user")) || 0;
      let result = await this.$http.post("user.php", {
        ApiKey: this.ApiKey,
        user_ID: userSession.user_ID
      });
      this.user_id = result.data;
    },

    async userLogin(user_name, user_password) {
      let data = {
        user_name: user_name,
        user_password: user_password
      };
      console.log("Login Data:", data);
      let result = await this.$http.post("login.php?crud=admin", data);
      console.log("Login Result:", result.data);
      if (result.data.user_status) {
        let user = result.data;
        user.system_lock = false;
        sessionStorage.setItem("user", JSON.stringify(user));
        const routes = {
          A: "/admin",
          B: "/college",
          C: "/iven",
          S: "/supervisions",
          D: "/personnel",
          G: "/vecprovince"
        };
        if (routes[user.user_status]) {
          this.$router.push(routes[user.user_status]);
        } else {
          sessionStorage.clear();
        }
      }
    },

    async sweetAlertLoading() {
      Swal.fire({
        title: "Please Wait !",
        timerProgressBar: true,
        didOpen: () => Swal.showLoading(),
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      });
    },

    async viewFile(file) {
      this.filesAss = file;
      this.assistant_teacher_filedialog = true;
    },

    async viewpdflicenseteach(file) {
      this.pt_licence_files = file;
      if (String(file).length > 4) {
        this.pdflicenseteachdialog = true;
      } else {
        Swal.fire({
          icon: "warning",
          title: "ไม่ได้แนบไฟล์",
          showConfirmButton: false,
          timer: 1500
        });
      }
    },

    async checkAssistant(assistant_teacher_id) {
      this.assistant_teachers_edit = [];
      let result = await this.$http.post("assistant_teacher_new.php", {
        ApiKey: this.ApiKey,
        assistant_teacher_id: assistant_teacher_id
      });
      this.assistant_teachers_edit = result.data;
      this.editpersonnel_temporaryCheckdialog = true;
    },

    async cancelAssistant(assistant_teacher_id) {
      let result_assistant = await this.$http.post(
        "assistant_teacher_new.php",
        {
          ApiKey: this.ApiKey,
          assistant_teacher_id: assistant_teacher_id
        }
      );
      this.assistant_teachers_edit = result_assistant.data;

      let textAlert =
        this.assistant_teachers_edit.frist_names +
        " ครั้งที่ : " +
        this.assistant_teachers_edit.assistant_teacher_times;

      Swal.fire({
        title: "ยกเลิกการรายงานคะแนน",
        text: textAlert,
        icon: "warning",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "ยืนยันยกเลิก",
        cancelButtonText: "ปิด",
        denyButtonText: "ไม่อนุญาต"
      }).then(async result => {
        if (result.isDenied) {
          this.assistant_teachers_edit.ApiKey = this.ApiKey;
          this.assistant_teachers_edit.assistant_teacher_comment = "";
          let res = await this.$http.post(
            "assistant_teacher.update.php",
            this.assistant_teachers_edit
          );
          if (res.data.status) {
            Swal.fire({
              icon: "success",
              title: "ดำเนินการเรียบร้อย",
              showConfirmButton: false,
              timer: 1500
            });
            await this.assistant_teacherscollegeCCQueryAll();
          }
        } else if (result.isConfirmed) {
          this.assistant_teachers_edit.ApiKey = this.ApiKey;
          await this.$http.post("deletefile.php", {
            ApiKey: this.ApiKey,
            filename:
              "../HRvecfiles/" +
              this.assistant_teachers_edit.assistant_teacher_file
          });

          // ลบ committee data ถ้าเป็นเกณฑ์ใหม่
          if (this.assistant_teachers_edit.criteria_version === "NEW") {
            await this.$http.post("assistant_teacher_committee.php", {
              ApiKey: this.ApiKey,
              action: "delete",
              assistant_teacher_id: this.assistant_teachers_edit
                .assistant_teacher_id
            });
          }

          this.assistant_teachers_edit.assistant_teacher_file = "";
          this.assistant_teachers_edit.assistant_teacher_comment = "CC";
          this.assistant_teachers_edit.assistant_teacher_comment_detail = "";
          this.assistant_teachers_edit.assistant_teacher_ipacheck = "";
          this.assistant_teachers_edit.assistant_teacher_ipacomment = "";

          await this.$http.post(
            "assistant_teacher.update.php",
            this.assistant_teachers_edit
          );

          // Clear manage_assistant_teacher
          this.Updatemanage_assistant_teacher.ApiKey = this.ApiKey;
          this.Updatemanage_assistant_teacher.mt_id_card = this.assistant_teachers_edit.assistant_teacher_id_card;
          const t = this.assistant_teachers_edit.assistant_teacher_times;
          const prefix = "mt_time_" + t;
          this.Updatemanage_assistant_teacher[prefix + "_file"] = "";
          this.Updatemanage_assistant_teacher[prefix + "_score_a"] = "";
          this.Updatemanage_assistant_teacher[prefix + "_score_b"] = "";
          this.Updatemanage_assistant_teacher[prefix + "_score"] = "";
          this.Updatemanage_assistant_teacher[prefix + "_ck"] = "";

          await this.$http.post(
            "manage_assistant_teacher.update.idcard.php",
            this.Updatemanage_assistant_teacher
          );

          Swal.fire({
            icon: "success",
            title: "ดำเนินการเรียบร้อย",
            showConfirmButton: false,
            timer: 1500
          });
          await this.assistant_teacherscollegeCCQueryAll();
          await this.assistant_teachersCCQueryAll();
        }
      });
    },

    async editassistant_teacherCancelSubmit() {
      await this.sweetAlertLoading();
      this.assistant_teachers_edit.ApiKey = this.ApiKey;

      const t = this.assistant_teachers_edit.assistant_teacher_times;
      this.Updatepersonnel_temporary = {};
      this.Updatepersonnel_temporary.ApiKey = this.ApiKey;
      this.Updatepersonnel_temporary.mt_id_card = this.assistant_teachers_edit.assistant_teacher_id_card;
      this.Updatepersonnel_temporary["mt_time_" + t + "_ck"] = "";

      this.assistant_teachers_edit.assistant_teacher_ipacheck = "";
      this.assistant_teachers_edit.assistant_teacher_ipacomment = "";
      this.assistant_teachers_edit.assistant_teacher_comment = "";
      this.assistant_teachers_edit.assistant_teacher_comment_detail = "";

      await this.$http.post(
        "manage_assistant_teacher.update.idcard.php",
        this.Updatepersonnel_temporary
      );
      let res = await this.$http.post(
        "assistant_teacher.update.php",
        this.assistant_teachers_edit
      );
      if (res.data.status) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.editpersonnel_temporaryCheckdialog = false;
      await this.checkappoint();
      await this.assistant_teacherscollegeCCQueryAll();
      await this.assistant_teachersCCQueryAll();
      Swal.close();
    },

    async editassistant_teacherSubmit() {
      if (this.$refs.editpersonnel_temporaryCheckform.validate()) {
        try {
          this.loading = true;
          this.assistant_teachers_edit.ApiKey = this.ApiKey;
          this.Updatepersonnel_temporary = {};
          this.Updatepersonnel_temporary.ApiKey = this.ApiKey;
          this.Updatepersonnel_temporary.mt_id_card = this.assistant_teachers_edit.assistant_teacher_id_card;

          const t = this.assistant_teachers_edit.assistant_teacher_times;
          const prefix = "mt_time_" + t;

          if (
            this.assistant_teachers_edit.assistant_teacher_ipacheck ===
            "NotPass"
          ) {
            this.Updatepersonnel_temporary[prefix + "_file"] = "";
            this.Updatepersonnel_temporary[prefix + "_ck"] = "NotPass";

            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename:
                "../HRvecfiles/" +
                this.assistant_teachers_edit.assistant_teacher_file
            });
            this.assistant_teachers_edit.assistant_teacher_file = "";
            this.assistant_teachers_edit.assistant_teacher_comment = "CC";
            this.assistant_teachers_edit.assistant_teacher_comment_detail = "";
          }

          if (
            this.assistant_teachers_edit.assistant_teacher_ipacheck === "Pass"
          ) {
            this.Updatepersonnel_temporary[prefix + "_ck"] = "Pass";
            this.assistant_teachers_edit.assistant_teacher_ipacomment = "";
            this.assistant_teachers_edit.assistant_teacher_comment = "";
            this.assistant_teachers_edit.assistant_teacher_comment_detail = "";
          }

          await this.$http.post(
            "manage_assistant_teacher.update.idcard.php",
            this.Updatepersonnel_temporary
          );
          await this.$http.post(
            "assistant_teacher.update.php",
            this.assistant_teachers_edit
          );

          this.editpersonnel_temporaryCheckdialog = false;
          await this.checkappoint();
        } finally {
          this.loading = false;
        }
      }
    },

    async assistant_teacherQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_new.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_lowscore: "ok"
        })
        .finally(() => (this.loading = false));
      this.manage_assistant_teacher = result.data;
    },

    async assistant_teacherscollegeCCQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_new.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_comment: "collegeCC"
        })
        .finally(() => (this.loading = false));
      this.assistant_teachers = result.data;
    },

    async assistant_teachersCCQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("assistant_teacher_new.php", {
          ApiKey: this.ApiKey,
          assistant_teacher_comment: "CC"
        })
        .finally(() => (this.loading = false));
      this.assistant_teachersCC = result.data;
    },

    async UpdateSystem() {
      this.loading = true;
      await this.$http
        .post("update_manage_assistant_teacher.php", {
          ApiKey: this.ApiKey
        })
        .finally(() => (this.loading = false));
    },

    async assistant_teacher_update() {
      await this.sweetAlertLoading();
      let result = await this.$http.post(
        "manage_assistant_teacher.updateadmin.clear.php",
        { ApiKey: this.ApiKey }
      );
      if (result.data.status) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
      }
      Swal.close();
    },

    async updateOrder() {
      this.updateorder_app_now.ApiKey = this.ApiKey;
      this.updateorder_app_now.appoin_day = this.appoin_day;
      this.updateorder_app_now.appoin_month = this.appoin_month;
      this.updateorder_app_now.appoin_year = this.appoin_year;
      this.updateorder_app_now_ms.ApiKey = this.ApiKey;
      this.updateorder_app_now_ms.mt_appoin_day = this.appoin_day;
      this.updateorder_app_now_ms.mt_appoin_month = this.appoin_month;
      this.updateorder_app_now_ms.mt_appoin_year = this.appoin_year;
      this.updateorder_app_now_ms.mt_order_app = this.updateorder_app_now.order_app_now;

      let res1 = await this.$http.post(
        "personnel_temporary.update.admin.order.php",
        this.updateorder_app_now
      );
      let res2 = await this.$http.post(
        "manage_assistant_teacher.updateadmin.order.php",
        this.updateorder_app_now_ms
      );
      if (res1.data.status || res2.data.status) {
        Swal.fire({
          icon: "success",
          title: "ดำเนินการเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        await this.checkappoint();
      }
    },

    async personnel_temporaryCollegeQueryAll() {
      this.loading = true;
      let result = await this.$http
        .post("manage_assistant_teacher_new.php", {
          ApiKey: this.ApiKey,
          fastQ: "ok",
          mt_college_code: this.college_select
        })
        .finally(() => (this.loading = false));
      this.manage_assistant_teacher = result.data;
    },

    async checkmanage_assistant_teacherid(e) {
      if (e.keyCode == 13) {
        this.loading = true;
        let result = await this.$http
          .post("manage_assistant_teacher_new.php", {
            ApiKey: this.ApiKey,
            mt_id_card: this.search,
            fastQ: "ok"
          })
          .finally(() => (this.loading = false));
        this.manage_assistant_teacher = result.data;
      }
    },

    async checkappoint() {
      try {
        this.loading = true;
        let appoin_day = this.appoin_day || 0;
        let appoin_month = this.appoin_month || 0;
        let appoin_year = this.appoin_year || 0;
        let dates = new Date(appoin_year + "-" + appoin_month + "-" + appoin_day);
        this.check_param_query = String(dates.getSeconds).length;

        if (parseInt(this.appoin_day) > 0) {
          let result = await this.$http.post(
            "manage_assistant_teacher.score.php",
            {
              ApiKey: this.ApiKey,
              mt_appoin_day: this.appoin_day,
              mt_appoin_month: this.appoin_month,
              mt_appoin_year: this.appoin_year,
              mt_type_personnel: this.mt_type_personnel || this.mt_type
            }
          );
          this.manage_assistant_teacher = result.data;

          // นับสถิติ
          let counts = 0;
          let stats = {};
          for (let t = 1; t <= 4; t++) {
            stats["counttime" + t + "pass"] = 0;
            stats["counttime" + t + "notpass"] = 0;
            stats["counttime" + t + "notcheck"] = 0;
            stats["counttime" + t + "null"] = 0;
            stats["counttime" + t + "lowscore"] = 0;
          }

          const thresholds = { 1: [24, 36], 2: [24, 36], 3: [28, 42], 4: [28, 42] };

          result.data.forEach(value => {
            counts++;
            for (let t = 1; t <= 4; t++) {
              const ck = value["mt_time_" + t + "_ck"];
              const score = parseFloat(value["mt_time_" + t + "_score"]) || 0;
              const scoreA = parseFloat(value["mt_time_" + t + "_score_a"]) || 0;
              const scoreB = parseFloat(value["mt_time_" + t + "_score_b"]) || 0;
              const passStatus = value["mt_time_" + t + "_pass_status"];
              const [thA, thB] = thresholds[t];

              if (ck === "Pass") stats["counttime" + t + "pass"]++;
              if (ck === "NotPass") stats["counttime" + t + "notpass"]++;
              if (score > 0 && ck !== "Pass" && ck !== "NotPass")
                stats["counttime" + t + "notcheck"]++;
              if (score <= 0 && !passStatus)
                stats["counttime" + t + "null"]++;

              // Lowscore: เกณฑ์เดิม
              if (value.criteria_version !== "NEW") {
                if (
                  (scoreA > 0 && scoreA < thA) ||
                  (scoreB > 0 && scoreB < thB)
                ) {
                  stats["counttime" + t + "lowscore"]++;
                }
              } else {
                // เกณฑ์ใหม่: นับ fail เป็น lowscore
                if (passStatus === "fail") {
                  stats["counttime" + t + "lowscore"]++;
                }
              }
            }
          });

          this.checkdatareport = { countall: counts, ...stats };
          this.timelowscore = stats;
        } else {
          await this.assistant_teacherQueryAll();
        }
      } finally {
        this.loading = false;
      }
    },

    async updateLicense(mt_id) {
      this.editmanage_assistant_teacher = [];
      let result = await this.$http.post("manage_assistant_teacher_new.php", {
        ApiKey: this.ApiKey,
        mt_id: mt_id
      });
      this.editmanage_assistant_teacher = result.data;
      this.cancel_Licensefiledialog = true;
    }
  },
  computed: {
    appoin_day() {
      return this.$route.query.appoin_day;
    },
    appoin_month() {
      return this.$route.query.appoin_month;
    },
    appoin_year() {
      return this.$route.query.appoin_year;
    },
    mt_admissions_status() {
      return this.$route.query.mt_admissions_status;
    },
    mt_type_personnel() {
      return this.$route.query.mt_type_personnel;
    },
    mt_type() {
      return this.$route.query.mt_type;
    },
    showHeaders() {
      return this.headers.filter(s => this.selectedHeaders.includes(s));
    },
    date_today() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      return dd + "/" + mm + "/" + yyyy;
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time =
        today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return dd + "/" + mm + "/" + yyyy + "/" + time;
    }
  }
};
</script>

<style scoped>
/* ===== Clean Professional — ไม่เน้นสีสัน ===== */
::v-deep .v-data-table {
  border-radius: 4px;
}
::v-deep .v-data-table thead th {
  background-color: #f5f5f5 !important;
  color: #333 !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  border-bottom: 2px solid #e0e0e0 !important;
  padding: 6px 4px !important;
  white-space: nowrap;
}
::v-deep .v-data-table tbody tr:hover {
  background-color: #fafafa !important;
}
::v-deep .v-data-table tbody td {
  font-size: 12px !important;
  padding: 4px !important;
  border-bottom: 1px solid #eee !important;
  vertical-align: middle !important;
}
::v-deep .v-data-table tbody tr:nth-child(even) {
  background-color: #fafbfc;
}
.summary-header td {
  background-color: #f5f5f5 !important;
  border-bottom: 2px solid #e0e0e0 !important;
  font-size: 12px !important;
}
::v-deep .v-simple-table td {
  padding: 4px 6px !important;
  font-size: 12px;
  border-bottom: 1px solid #eee !important;
}
::v-deep .v-btn {
  text-transform: none !important;
  letter-spacing: 0 !important;
}
::v-deep .v-card--outlined {
  border-color: #e0e0e0 !important;
}
@media (max-width: 960px) {
  ::v-deep .v-data-table thead th,
  ::v-deep .v-data-table tbody td {
    font-size: 10px !important;
    padding: 2px !important;
  }
}
</style>